import { tableConfig } from "../config/table.config";

export const cleanEmptyParams = <T extends Record<string, unknown>>(
  search: T
) => {
  const newSearch = { ...search };
  Object.keys(newSearch).forEach((key) => {
    const value = newSearch[key];
    if (
      value === undefined ||
      value === "" ||
      (typeof value === "number" && isNaN(value))
    )
      delete newSearch[key];
  });

  if (search.pageIndex === tableConfig.pageIndex) delete newSearch.pageIndex;
  if (search.pageSize === tableConfig.pageSize) delete newSearch.pageSize;

  return newSearch;
};